import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-374e886d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "loading" }
const _hoisted_3 = { class: "table" }
const _hoisted_4 = { class: "no-users" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QueueMemberDetails = _resolveComponent("QueueMemberDetails")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, " Loading Members... ", 512), [
      [_vShow, _ctx.isLoading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.queueMembers, (queueMember) => {
        return (_openBlock(), _createElementBlock("div", {
          key: queueMember.id
        }, [
          _createVNode(_component_QueueMemberDetails, { queueMember: queueMember }, null, 8, ["queueMember"])
        ]))
      }), 128))
    ], 512), [
      [_vShow, !_ctx.isLoading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, " No users assigned in this queue. 😞 ", 512), [
      [_vShow, _ctx.showNoUsers]
    ])
  ]))
}